import React from 'react'
import Text from '../../text/Text'
import SvgIcon from '../../svgIcon/SvgIcon'
import { UpsellingActiveStyles } from './activeStyle'

export interface UpsellingActiveProperties {
    btn: { title: string; action: () => void }
    title?: string
    image: any
}

export function UpsellingActive(properties: UpsellingActiveProperties) {
    return (
        <div style={UpsellingActiveStyles.container}>
            <div style={UpsellingActiveStyles.header}>
                <img
                    src={properties.image}
                    alt="imagen"
                    style={{ maxWidth: 400 }}
                />
            </div>
            <div style={UpsellingActiveStyles.subtitleContainer}>
                <div style={UpsellingActiveStyles.IconCheckGreenStyle}>
                    <SvgIcon iconName="IconCheckGreen" />
                </div>
                <Text
                    label="¡Ya mejoraste tu plan!"
                    fontWeight={600}
                    color="#0086D6"
                    fontSize={20}
                    fontFamily={'Poppins'}
                />
            </div>
            <div style={UpsellingActiveStyles.textContainer}>
                <Text
                    label="¡FELICITACIONES! 🥳"
                    textAlign="center"
                    marginBottom={25}
                    fontWeight={700}
                    color="#0086D6"
                    fontSize={41}
                    lineHeight={0.5}
                    fontFamily={'Poppins'}
                />
                {properties.title && (
                    <Text
                        label={properties.title}
                        textAlign="center"
                        marginBottom={35}
                        fontWeight={700}
                        color="#0086D6"
                        fontSize={41}
                        lineHeight={1}
                        style={{ whiteSpace: 'pre-line' }}
                        fontFamily={'Poppins'}
                    />
                )}
            </div>
            <div style={UpsellingActiveStyles.actions}>
                <button
                    onClick={properties.btn.action}
                    style={UpsellingActiveStyles.btn}
                >
                    <Text
                        label={properties.btn.title}
                        fontWeight={600}
                        fontSize={16}
                        color="#fff"
                    />
                </button>
            </div>
        </div>
    )
}
